// Shared URL-param helpers for the tracking tabs. Each tracking tab owns
// a set of "scoped" params (search, filters, sort, pagination, view) that
// belong to that tab alone. When the user switches tabs or follows a
// cross-tab link these params must not carry over to the destination tab,
// otherwise the destination appears filtered/searched by the source tab's
// state — e.g. a deliverable search term would hide all milestones.

/** Remove all tab-scoped params from `params` in-place.
 *
 * Tab-scoped keys:
 *   `q`, `sort`, `dir`, `page`, `pageSize`, `view`, `scope`, `range`
 *   and any key starting with `filters[`.
 *
 * `range` is the Reports tab's reporting window. It is scoped for the same
 * reason `view` is: a window selected while reading a report means nothing on
 * a register tab, and carrying it across would leave a stale param in every
 * subsequent deep link.
 *
 * Non-scoped keys such as `tab`, `item`, `openPeopleAccess`, `action`,
 * `sowId`, `linkedType`, `linkedId` are left untouched.
 *
 * Iterates a snapshot of keys (spread into an array) so mutation during
 * iteration does not skip entries.
 */
export function clearTabScopedParams(params: URLSearchParams): void {
  const NAMED_KEYS = new Set([
    "q",
    "sort",
    "dir",
    "page",
    "pageSize",
    "view",
    "scope",
    "range",
  ]);
  for (const key of [...params.keys()]) {
    if (NAMED_KEYS.has(key) || key.startsWith("filters[")) {
      params.delete(key);
    }
  }
}
